export const secondaryGradient = ["#27AE60", "#73CB98"];
export const primaryGradient = ["#2F80ED", "#5698F0"];
